let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("56pLh")).then(() => parcelRequire('3B3mf'));